import React from "react";
import { FaWindowMinimize, FaTimes } from "react-icons/fa";
import { ChatHeaderProps } from "./types";

const ChatHeader: React.FC<ChatHeaderProps> = ({ onClose }) => (
  <div className="flex justify-between items-center bg-secondary text-white p-2">
    <div className="font-medium">Chat</div>
    <div className="flex space-x-2">
      <button
        aria-label="Minimize chat window"
        onClick={onClose}
        className="p-1 hover:bg-gray-200 rounded"
      >
        <FaWindowMinimize className="text-lg text-white" />
      </button>
      <button
        aria-label="Close chat window"
        onClick={onClose}
        className="p-1 hover:bg-gray-200 rounded"
      >
        <FaTimes className="text-lg text-white" />
      </button>
    </div>
  </div>
);

export default ChatHeader;
